import { Form } from '../../classes/Form';

export default {
    namespaced: true,

    state: {
        gender: null,
        logged: false,
        user: null,
        modal: false,
        form: 'login',
        availableForms: [
            'login',
            'registration',
            'remember'
        ],
        login: new Form({
            type: 'phone_number',
            phone_number: '',
            email: '',
            password: '',
        }),
        remember: new Form({
            type: 'phone_number',
            phone_number: '',
            email: '',
        }),
        registration: new Form({
            first_name: '',
            last_name: '',
            middle_name: '',
            gender: '0',
            phone_number: '',
            email: '',
            password: '',
            subscribe: true,
            accept: false,
        }),
        stayOnPageAfterAuth: false,
        hashAfterAuth: null,
    },

    getters: {
        hasError: (state) => (field) => {
           return state[state.form].errors.has(field);
        },

        getError: (state) => (field) => {
            return state[state.form].errors.get(field);
        },

        isCorrectFormName: (state) => (form) => {
            return state.availableForms.indexOf(form) !== -1;
        }
    },

    mutations: {
        setGender (state, gender) {
            state.gender = gender;
        },

        setLogged (state, logged) {
            state.logged = logged;
        },

        showModal (state) {
            state.modal = true;
        },

        hideModal (state) {
            state.modal = false;
        },

        setForm (state, form) {
            if (state.availableForms.indexOf(form) !== -1) {
                state.form = form;
            }
            if (form === 'registration') {
                window.events.onClickRegister();
            }
        },

        setFormValue (state, { key, value, formName = '' }) {
            const form = formName? state[formName] : state[state.form];

            if (form) {
                form.errors.clear(key);

                form[key] = value;
            }
        },

        stayOnPageAfterAuth (state, hash) {
            state.stayOnPageAfterAuth  = true;

            if (hash) {
                state.hashAfterAuth = hash;
            }
        },

        setUser (state, user) {
            state.user = user;
        }
    },

    actions: {
        login ({ dispatch, state }) {
            state.login.post('/login')
                .then(response => {
                    dispatch('processAuthResponse', response);
                })
                .catch(error => {
                    console.log('Login error');
                    console.log(error);
                });
        },

        register ({ dispatch, state }) {
            state.registration.post('/register')
                .then(response => {
                    window.events.onClickRegistered();

                    dispatch('processAuthResponse', response);
                })
                .catch(error => {
                    console.log('Registration error');
                    console.log(error);
                });
        },

        processAuthResponse ({ state }, response) {
            if (response.redirect && !state.stayOnPageAfterAuth) {
                window.location.href = response.redirect;

                return;
            }

            if (state.hashAfterAuth) {
                window.location.hash = state.hashAfterAuth;
            }

            window.location.reload();
        },

        logout () {
            axios.post('/logout')
                .then(() => {
                    window.location.reload();
                })
                .catch(error => {
                    console.log('Logout error');
                    console.log(error);
                });
        }
    }
}
